package flagpack.icons.medium

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Peru Flag (20x15dp)
 *
 * - ISO Alpha-2: PE
 * - ISO Alpha-3: PER
 * - ISO Numeric: 604
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Medium.Peru: ImageVector by lazy {
    ImageVector.Builder(
        name = "Peru:PE:PER:604:Medium",
        defaultWidth = 20.dp,
        defaultHeight = 15.dp,
        viewportWidth = 20f,
        viewportHeight = 15f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(20f)
                verticalLineToRelative(15f)
                horizontalLineToRelative(-20f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(5f, 0f)
                horizontalLineTo(15.625f)
                verticalLineTo(15f)
                horizontalLineTo(5f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF50101)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(15f, 0f)
                horizontalLineTo(20f)
                verticalLineTo(15f)
                horizontalLineTo(15f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF50101)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                horizontalLineTo(5f)
                verticalLineTo(15f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(fill = SolidColor(Color(0xFFA2BB6A))) {
                moveTo(9.838f, 5.466f)
                lineTo(9.859f, 5.692f)
                curveTo(9.235f, 5.755f, 8.898f, 5.45f, 8.898f, 4.817f)
                curveTo(8.898f, 4.189f, 9.228f, 3.856f, 9.848f, 3.852f)
                lineTo(9.849f, 4.079f)
                curveTo(9.347f, 4.082f, 9.116f, 4.316f, 9.116f, 4.817f)
                curveTo(9.116f, 5.313f, 9.34f, 5.516f, 9.838f, 5.466f)
                close()
            }
            path(fill = SolidColor(Color(0xFFA2BB6A))) {
                moveTo(10.115f, 5.466f)
                lineTo(10.094f, 5.692f)
                curveTo(10.718f, 5.755f, 11.055f, 5.45f, 11.055f, 4.817f)
                curveTo(11.055f, 4.189f, 10.725f, 3.856f, 10.105f, 3.852f)
                lineTo(10.104f, 4.079f)
                curveTo(10.606f, 4.082f, 10.837f, 4.316f, 10.837f, 4.817f)
                curveTo(10.837f, 5.313f, 10.613f, 5.516f, 10.115f, 5.466f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE31D1C)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9.462f, 10.702f)
                curveTo(9.283f, 10.766f, 8.066f, 10.702f, 8.066f, 10.702f)
                verticalLineTo(11.041f)
                horizontalLineTo(8.873f)
                curveTo(9.142f, 11.041f, 9.244f, 11.089f, 9.337f, 11.133f)
                curveTo(9.416f, 11.17f, 9.489f, 11.205f, 9.653f, 11.205f)
                curveTo(9.972f, 11.205f, 9.966f, 10.968f, 9.961f, 10.77f)
                curveTo(9.961f, 10.747f, 9.96f, 10.724f, 9.96f, 10.702f)
                curveTo(9.96f, 10.618f, 9.973f, 10.571f, 9.983f, 10.535f)
                curveTo(9.998f, 10.482f, 10.007f, 10.451f, 9.96f, 10.359f)
                curveTo(9.881f, 10.205f, 9.13f, 10.226f, 9.13f, 10.359f)
                curveTo(9.13f, 10.422f, 9.244f, 10.488f, 9.345f, 10.546f)
                curveTo(9.459f, 10.611f, 9.557f, 10.668f, 9.462f, 10.702f)
                close()
                moveTo(10.556f, 10.702f)
                curveTo(10.735f, 10.766f, 11.952f, 10.702f, 11.952f, 10.702f)
                verticalLineTo(11.041f)
                horizontalLineTo(11.145f)
                curveTo(10.876f, 11.041f, 10.774f, 11.089f, 10.681f, 11.133f)
                curveTo(10.602f, 11.17f, 10.529f, 11.205f, 10.365f, 11.205f)
                curveTo(10.046f, 11.205f, 10.052f, 10.968f, 10.057f, 10.77f)
                curveTo(10.057f, 10.747f, 10.058f, 10.724f, 10.058f, 10.702f)
                curveTo(10.058f, 10.618f, 10.045f, 10.571f, 10.035f, 10.535f)
                curveTo(10.02f, 10.482f, 10.011f, 10.451f, 10.058f, 10.359f)
                curveTo(10.137f, 10.205f, 10.888f, 10.226f, 10.888f, 10.359f)
                curveTo(10.888f, 10.422f, 10.774f, 10.488f, 10.673f, 10.546f)
                curveTo(10.559f, 10.611f, 10.461f, 10.668f, 10.556f, 10.702f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF00A854)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(10.254f, 10.734f)
                curveTo(10.254f, 10.734f, 11.204f, 10.64f, 11.418f, 10.297f)
                curveTo(11.633f, 9.955f, 11.991f, 9.371f, 12.117f, 9.229f)
                curveTo(12.242f, 9.088f, 12.25f, 9.431f, 12.25f, 9.431f)
                curveTo(12.25f, 9.431f, 12.458f, 9.726f, 12.458f, 9.349f)
                curveTo(12.458f, 8.973f, 12.31f, 9.236f, 12.117f, 8.67f)
                curveTo(11.923f, 8.104f, 11.814f, 7.548f, 11.868f, 7.464f)
                curveTo(11.923f, 7.38f, 12.052f, 7.548f, 12.052f, 7.464f)
                curveTo(12.052f, 7.38f, 12.052f, 7.216f, 12.052f, 7.216f)
                lineTo(12.25f, 7.464f)
                lineTo(12.458f, 7.386f)
                curveTo(12.458f, 7.386f, 12.629f, 7.751f, 12.734f, 7.865f)
                curveTo(12.839f, 7.978f, 12.901f, 7.713f, 12.87f, 7.464f)
                curveTo(12.839f, 7.216f, 12.458f, 7.216f, 12.458f, 7.216f)
                curveTo(12.458f, 7.216f, 11.97f, 6.953f, 11.97f, 6.843f)
                curveTo(11.97f, 6.733f, 12.181f, 6.765f, 12.181f, 6.765f)
                lineTo(12.117f, 6.424f)
                curveTo(12.117f, 6.424f, 12.291f, 6.632f, 12.374f, 6.528f)
                curveTo(12.458f, 6.424f, 12.25f, 6.243f, 12.25f, 6.243f)
                horizontalLineTo(12.581f)
                verticalLineTo(6.083f)
                lineTo(12.734f, 6.169f)
                lineTo(12.581f, 5.82f)
                curveTo(12.581f, 5.82f, 12.133f, 5.887f, 12.052f, 5.82f)
                curveTo(11.97f, 5.752f, 11.714f, 5.489f, 11.714f, 5.489f)
                verticalLineTo(5.365f)
                horizontalLineTo(11.566f)
                lineTo(11.714f, 5.114f)
                verticalLineTo(4.716f)
                lineTo(12.25f, 4.823f)
                verticalLineTo(4.528f)
                curveTo(12.25f, 4.528f, 13.006f, 4.896f, 12.87f, 5.193f)
                curveTo(12.734f, 5.489f, 12.734f, 5.82f, 12.734f, 5.82f)
                verticalLineTo(6.083f)
                curveTo(12.734f, 6.083f, 12.757f, 6.002f, 12.87f, 6.002f)
                curveTo(12.983f, 6.002f, 13.112f, 6.061f, 13.112f, 6.243f)
                curveTo(13.112f, 6.424f, 13.343f, 6.169f, 13.343f, 6.169f)
                verticalLineTo(6.925f)
                curveTo(13.343f, 6.925f, 13.397f, 7.006f, 13.516f, 6.925f)
                curveTo(13.634f, 6.843f, 13.582f, 6.907f, 13.226f, 7.386f)
                curveTo(12.87f, 7.865f, 12.998f, 7.866f, 13.112f, 7.748f)
                curveTo(13.226f, 7.631f, 13.689f, 7.297f, 13.516f, 7.464f)
                curveTo(13.343f, 7.631f, 13.332f, 7.981f, 13.516f, 7.865f)
                curveTo(13.7f, 7.748f, 13.665f, 7.666f, 13.665f, 7.865f)
                curveTo(13.665f, 8.063f, 13.34f, 8.739f, 13.226f, 8.845f)
                curveTo(13.112f, 8.951f, 13.006f, 9.016f, 12.87f, 9.123f)
                curveTo(12.734f, 9.229f, 12.581f, 9.355f, 12.581f, 9.431f)
                curveTo(12.581f, 9.508f, 12.87f, 9.349f, 12.87f, 9.349f)
                lineTo(12.734f, 9.835f)
                horizontalLineTo(12.998f)
                curveTo(12.998f, 9.835f, 12.788f, 10.479f, 12.374f, 10.479f)
                curveTo(11.961f, 10.479f, 11.649f, 10.479f, 11.566f, 10.479f)
                curveTo(11.483f, 10.479f, 11.108f, 10.656f, 11.108f, 10.656f)
                lineTo(10.833f, 10.734f)
                curveTo(10.833f, 10.734f, 11.271f, 10.776f, 11.418f, 10.908f)
                curveTo(11.566f, 11.039f, 11.418f, 11.131f, 11.418f, 11.131f)
                curveTo(11.418f, 11.131f, 11.013f, 11.09f, 10.711f, 10.999f)
                curveTo(10.408f, 10.908f, 10.254f, 11.081f, 10.254f, 10.908f)
                curveTo(10.254f, 10.734f, 10.254f, 10.734f, 10.254f, 10.734f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFC51918)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(12.989f, 5.568f)
                curveTo(12.989f, 5.631f, 12.941f, 5.682f, 12.88f, 5.682f)
                curveTo(12.82f, 5.682f, 12.772f, 5.631f, 12.772f, 5.568f)
                curveTo(12.772f, 5.505f, 12.82f, 5.455f, 12.88f, 5.455f)
                curveTo(12.941f, 5.455f, 12.989f, 5.505f, 12.989f, 5.568f)
                close()
                moveTo(12.446f, 6.023f)
                curveTo(12.446f, 6.085f, 12.397f, 6.136f, 12.337f, 6.136f)
                curveTo(12.277f, 6.136f, 12.228f, 6.085f, 12.228f, 6.023f)
                curveTo(12.228f, 5.96f, 12.277f, 5.909f, 12.337f, 5.909f)
                curveTo(12.397f, 5.909f, 12.446f, 5.96f, 12.446f, 6.023f)
                close()
                moveTo(12.989f, 5.909f)
                curveTo(13.049f, 5.909f, 13.098f, 5.858f, 13.098f, 5.795f)
                curveTo(13.098f, 5.733f, 13.049f, 5.682f, 12.989f, 5.682f)
                curveTo(12.929f, 5.682f, 12.88f, 5.733f, 12.88f, 5.795f)
                curveTo(12.88f, 5.858f, 12.929f, 5.909f, 12.989f, 5.909f)
                close()
                moveTo(12.772f, 7.614f)
                curveTo(12.772f, 7.676f, 12.723f, 7.727f, 12.663f, 7.727f)
                curveTo(12.603f, 7.727f, 12.554f, 7.676f, 12.554f, 7.614f)
                curveTo(12.554f, 7.551f, 12.603f, 7.5f, 12.663f, 7.5f)
                curveTo(12.723f, 7.5f, 12.772f, 7.551f, 12.772f, 7.614f)
                close()
                moveTo(12.228f, 9.091f)
                curveTo(12.288f, 9.091f, 12.337f, 9.04f, 12.337f, 8.977f)
                curveTo(12.337f, 8.915f, 12.288f, 8.864f, 12.228f, 8.864f)
                curveTo(12.168f, 8.864f, 12.12f, 8.915f, 12.12f, 8.977f)
                curveTo(12.12f, 9.04f, 12.168f, 9.091f, 12.228f, 9.091f)
                close()
                moveTo(13.098f, 9.318f)
                curveTo(13.098f, 9.381f, 13.049f, 9.432f, 12.989f, 9.432f)
                curveTo(12.929f, 9.432f, 12.88f, 9.381f, 12.88f, 9.318f)
                curveTo(12.88f, 9.255f, 12.929f, 9.205f, 12.989f, 9.205f)
                curveTo(13.049f, 9.205f, 13.098f, 9.255f, 13.098f, 9.318f)
                close()
                moveTo(13.207f, 9.205f)
                curveTo(13.267f, 9.205f, 13.315f, 9.154f, 13.315f, 9.091f)
                curveTo(13.315f, 9.028f, 13.267f, 8.977f, 13.207f, 8.977f)
                curveTo(13.146f, 8.977f, 13.098f, 9.028f, 13.098f, 9.091f)
                curveTo(13.098f, 9.154f, 13.146f, 9.205f, 13.207f, 9.205f)
                close()
                moveTo(13.207f, 7.5f)
                curveTo(13.207f, 7.563f, 13.158f, 7.614f, 13.098f, 7.614f)
                curveTo(13.038f, 7.614f, 12.989f, 7.563f, 12.989f, 7.5f)
                curveTo(12.989f, 7.437f, 13.038f, 7.386f, 13.098f, 7.386f)
                curveTo(13.158f, 7.386f, 13.207f, 7.437f, 13.207f, 7.5f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF00A854)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9.803f, 10.534f)
                curveTo(9.803f, 10.534f, 8.076f, 10.193f, 7.982f, 9.532f)
                curveTo(7.887f, 8.871f, 7.889f, 8.168f, 7.889f, 8.168f)
                lineTo(7.728f, 8.598f)
                curveTo(7.728f, 8.598f, 7.72f, 8.012f, 8.049f, 7.595f)
                curveTo(8.377f, 7.178f, 7.638f, 7.872f, 7.638f, 7.872f)
                curveTo(7.638f, 7.872f, 8.012f, 7.281f, 8.168f, 7.225f)
                curveTo(8.324f, 7.169f, 7.542f, 7.595f, 7.542f, 7.595f)
                curveTo(7.542f, 7.595f, 7.766f, 7.1f, 7.94f, 6.96f)
                curveTo(8.114f, 6.82f, 7.542f, 7.225f, 7.542f, 7.225f)
                curveTo(7.542f, 7.225f, 7.672f, 6.734f, 7.827f, 6.617f)
                curveTo(7.981f, 6.5f, 7.32f, 7.225f, 7.32f, 7.225f)
                curveTo(7.32f, 7.225f, 7.669f, 6.103f, 7.866f, 5.998f)
                curveTo(8.062f, 5.894f, 7.542f, 6.204f, 7.542f, 6.204f)
                curveTo(7.542f, 6.204f, 7.861f, 5.724f, 8.146f, 5.485f)
                curveTo(8.431f, 5.247f, 7.63f, 5.587f, 7.728f, 5.587f)
                curveTo(7.728f, 5.587f, 8.018f, 5.26f, 8.184f, 5.168f)
                curveTo(8.351f, 5.076f, 7.542f, 5.485f, 7.542f, 5.485f)
                curveTo(7.542f, 5.485f, 8.123f, 4.845f, 8.297f, 4.751f)
                curveTo(8.47f, 4.656f, 7.442f, 5.259f, 7.442f, 5.259f)
                curveTo(7.442f, 5.259f, 7.503f, 4.98f, 7.528f, 4.78f)
                curveTo(7.554f, 4.581f, 7.052f, 5.327f, 7.12f, 5.998f)
                curveTo(7.189f, 6.669f, 6.847f, 5.485f, 6.847f, 5.485f)
                curveTo(6.847f, 5.485f, 6.71f, 5.742f, 7.043f, 6.415f)
                lineTo(6.682f, 5.909f)
                curveTo(6.682f, 5.909f, 6.731f, 6.369f, 6.847f, 6.617f)
                curveTo(6.963f, 6.865f, 6.518f, 6.204f, 6.518f, 6.204f)
                curveTo(6.518f, 6.204f, 6.433f, 6.617f, 6.518f, 6.617f)
                curveTo(6.518f, 6.617f, 7.026f, 7.296f, 7.045f, 7.493f)
                curveTo(7.064f, 7.691f, 6.474f, 6.787f, 6.396f, 6.787f)
                curveTo(6.317f, 6.787f, 6.273f, 7.077f, 6.396f, 7.077f)
                curveTo(6.518f, 7.077f, 6.75f, 7.493f, 6.75f, 7.493f)
                curveTo(6.75f, 7.493f, 6.449f, 7.275f, 6.384f, 7.262f)
                curveTo(6.319f, 7.25f, 6.435f, 7.392f, 6.518f, 7.493f)
                curveTo(6.518f, 7.493f, 6.282f, 7.686f, 6.3f, 7.832f)
                curveTo(6.318f, 7.977f, 6.943f, 8.008f, 7.216f, 8.7f)
                curveTo(7.216f, 8.7f, 6.652f, 8.402f, 6.518f, 8.402f)
                curveTo(6.384f, 8.402f, 6.734f, 8.713f, 6.847f, 8.816f)
                curveTo(6.96f, 8.919f, 6.673f, 8.713f, 6.596f, 8.816f)
                curveTo(6.518f, 8.919f, 7.025f, 9.357f, 7.12f, 9.357f)
                curveTo(7.216f, 9.357f, 6.75f, 9.357f, 6.75f, 9.357f)
                curveTo(6.75f, 9.357f, 6.874f, 9.532f, 7.045f, 9.532f)
                curveTo(7.216f, 9.532f, 7.827f, 9.806f, 7.827f, 9.895f)
                curveTo(7.827f, 9.984f, 7.311f, 9.782f, 7.216f, 9.782f)
                curveTo(7.12f, 9.782f, 7.888f, 10.507f, 8.297f, 10.534f)
                curveTo(8.705f, 10.562f, 8.962f, 10.671f, 9.138f, 10.671f)
                curveTo(9.314f, 10.671f, 9.438f, 10.671f, 9.438f, 10.671f)
                lineTo(8.607f, 11.095f)
                curveTo(8.607f, 11.095f, 8.523f, 11.095f, 8.883f, 11.095f)
                curveTo(9.244f, 11.095f, 9.52f, 11.195f, 9.662f, 10.988f)
                curveTo(9.803f, 10.781f, 9.803f, 10.534f, 9.803f, 10.534f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFE8AA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(10.054f, 5.566f)
                curveTo(10.071f, 5.556f, 10.08f, 5.551f, 10.08f, 5.551f)
                verticalLineTo(5.58f)
                curveTo(10.2f, 5.647f, 10.503f, 5.802f, 10.7f, 5.802f)
                curveTo(10.951f, 5.802f, 11.291f, 5.551f, 11.291f, 5.551f)
                lineTo(11.861f, 6.355f)
                curveTo(11.861f, 6.355f, 11.477f, 7.159f, 11.771f, 8.141f)
                curveTo(12.064f, 9.124f, 11.755f, 9.881f, 10.45f, 9.965f)
                curveTo(10.45f, 9.965f, 10.193f, 10.014f, 10.08f, 10.092f)
                verticalLineTo(10.164f)
                curveTo(10.08f, 10.146f, 10.071f, 10.129f, 10.054f, 10.113f)
                curveTo(10.038f, 10.129f, 10.028f, 10.146f, 10.028f, 10.164f)
                verticalLineTo(10.092f)
                curveTo(9.916f, 10.014f, 9.658f, 9.965f, 9.658f, 9.965f)
                curveTo(8.353f, 9.881f, 8.044f, 9.124f, 8.338f, 8.141f)
                curveTo(8.631f, 7.159f, 8.248f, 6.355f, 8.248f, 6.355f)
                lineTo(8.817f, 5.551f)
                curveTo(8.817f, 5.551f, 9.158f, 5.802f, 9.408f, 5.802f)
                curveTo(9.605f, 5.802f, 9.908f, 5.647f, 10.028f, 5.58f)
                verticalLineTo(5.551f)
                curveTo(10.028f, 5.551f, 10.038f, 5.556f, 10.054f, 5.566f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(7.236f, 3.551f)
                horizontalLineToRelative(6f)
                verticalLineToRelative(8f)
                horizontalLineToRelative(-6f)
                close()
                moveTo(10.054f, 5.566f)
                curveTo(10.071f, 5.556f, 10.08f, 5.551f, 10.08f, 5.551f)
                verticalLineTo(5.58f)
                curveTo(10.2f, 5.647f, 10.503f, 5.802f, 10.7f, 5.802f)
                curveTo(10.951f, 5.802f, 11.291f, 5.551f, 11.291f, 5.551f)
                lineTo(11.861f, 6.355f)
                curveTo(11.861f, 6.355f, 11.477f, 7.159f, 11.771f, 8.141f)
                curveTo(12.064f, 9.124f, 11.755f, 9.881f, 10.45f, 9.965f)
                curveTo(10.45f, 9.965f, 10.193f, 10.014f, 10.08f, 10.092f)
                verticalLineTo(10.164f)
                curveTo(10.08f, 10.146f, 10.071f, 10.129f, 10.054f, 10.113f)
                curveTo(10.038f, 10.129f, 10.028f, 10.146f, 10.028f, 10.164f)
                verticalLineTo(10.092f)
                curveTo(9.916f, 10.014f, 9.658f, 9.965f, 9.658f, 9.965f)
                curveTo(8.353f, 9.881f, 8.044f, 9.124f, 8.338f, 8.141f)
                curveTo(8.631f, 7.159f, 8.248f, 6.355f, 8.248f, 6.355f)
                lineTo(8.817f, 5.551f)
                curveTo(8.817f, 5.551f, 9.158f, 5.802f, 9.408f, 5.802f)
                curveTo(9.605f, 5.802f, 9.908f, 5.647f, 10.028f, 5.58f)
                verticalLineTo(5.551f)
                curveTo(10.028f, 5.551f, 10.038f, 5.556f, 10.054f, 5.566f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFFE8AA00))) {
                moveTo(10.08f, 5.551f)
                horizontalLineTo(10.705f)
                verticalLineTo(4.451f)
                lineTo(9.76f, 5.014f)
                lineTo(10.08f, 5.551f)
                close()
                moveTo(10.054f, 5.566f)
                lineTo(9.746f, 6.11f)
                lineTo(10.054f, 6.284f)
                lineTo(10.362f, 6.11f)
                lineTo(10.054f, 5.566f)
                close()
                moveTo(10.08f, 5.58f)
                horizontalLineTo(9.455f)
                verticalLineTo(5.949f)
                lineTo(9.778f, 6.128f)
                lineTo(10.08f, 5.58f)
                close()
                moveTo(11.291f, 5.551f)
                lineTo(11.801f, 5.19f)
                lineTo(11.433f, 4.669f)
                lineTo(10.92f, 5.048f)
                lineTo(11.291f, 5.551f)
                close()
                moveTo(11.861f, 6.355f)
                lineTo(12.425f, 6.624f)
                lineTo(12.583f, 6.293f)
                lineTo(12.371f, 5.994f)
                lineTo(11.861f, 6.355f)
                close()
                moveTo(11.771f, 8.141f)
                lineTo(11.172f, 8.32f)
                lineTo(11.771f, 8.141f)
                close()
                moveTo(10.45f, 9.965f)
                lineTo(10.41f, 9.342f)
                lineTo(10.371f, 9.344f)
                lineTo(10.333f, 9.351f)
                lineTo(10.45f, 9.965f)
                close()
                moveTo(10.08f, 10.092f)
                lineTo(9.725f, 9.578f)
                lineTo(9.455f, 9.764f)
                verticalLineTo(10.092f)
                horizontalLineTo(10.08f)
                close()
                moveTo(10.054f, 10.113f)
                lineTo(10.492f, 9.667f)
                lineTo(10.054f, 9.238f)
                lineTo(9.617f, 9.667f)
                lineTo(10.054f, 10.113f)
                close()
                moveTo(10.028f, 10.092f)
                horizontalLineTo(10.653f)
                verticalLineTo(9.764f)
                lineTo(10.384f, 9.578f)
                lineTo(10.028f, 10.092f)
                close()
                moveTo(9.658f, 9.965f)
                lineTo(9.775f, 9.351f)
                lineTo(9.737f, 9.344f)
                lineTo(9.699f, 9.342f)
                lineTo(9.658f, 9.965f)
                close()
                moveTo(8.248f, 6.355f)
                lineTo(7.738f, 5.994f)
                lineTo(7.526f, 6.293f)
                lineTo(7.684f, 6.624f)
                lineTo(8.248f, 6.355f)
                close()
                moveTo(8.817f, 5.551f)
                lineTo(9.189f, 5.048f)
                lineTo(8.676f, 4.669f)
                lineTo(8.307f, 5.19f)
                lineTo(8.817f, 5.551f)
                close()
                moveTo(10.028f, 5.58f)
                lineTo(10.33f, 6.128f)
                lineTo(10.653f, 5.949f)
                verticalLineTo(5.58f)
                horizontalLineTo(10.028f)
                close()
                moveTo(10.028f, 5.551f)
                lineTo(10.348f, 5.014f)
                lineTo(9.403f, 4.451f)
                verticalLineTo(5.551f)
                horizontalLineTo(10.028f)
                close()
                moveTo(10.08f, 5.551f)
                curveTo(9.76f, 5.014f, 9.76f, 5.014f, 9.76f, 5.014f)
                curveTo(9.76f, 5.014f, 9.76f, 5.014f, 9.76f, 5.014f)
                curveTo(9.76f, 5.014f, 9.76f, 5.014f, 9.76f, 5.014f)
                curveTo(9.76f, 5.014f, 9.76f, 5.014f, 9.76f, 5.014f)
                curveTo(9.76f, 5.014f, 9.76f, 5.014f, 9.76f, 5.014f)
                curveTo(9.761f, 5.014f, 9.761f, 5.014f, 9.761f, 5.014f)
                curveTo(9.761f, 5.014f, 9.761f, 5.014f, 9.761f, 5.014f)
                curveTo(9.761f, 5.013f, 9.761f, 5.013f, 9.761f, 5.014f)
                curveTo(9.761f, 5.014f, 9.76f, 5.014f, 9.759f, 5.015f)
                curveTo(9.756f, 5.016f, 9.752f, 5.019f, 9.746f, 5.022f)
                lineTo(10.362f, 6.11f)
                curveTo(10.373f, 6.104f, 10.382f, 6.099f, 10.388f, 6.095f)
                curveTo(10.391f, 6.093f, 10.394f, 6.092f, 10.396f, 6.09f)
                curveTo(10.397f, 6.09f, 10.398f, 6.089f, 10.398f, 6.089f)
                curveTo(10.399f, 6.089f, 10.399f, 6.088f, 10.399f, 6.088f)
                curveTo(10.4f, 6.088f, 10.4f, 6.088f, 10.4f, 6.088f)
                curveTo(10.4f, 6.088f, 10.4f, 6.088f, 10.4f, 6.088f)
                curveTo(10.4f, 6.088f, 10.4f, 6.088f, 10.4f, 6.088f)
                curveTo(10.4f, 6.088f, 10.4f, 6.088f, 10.4f, 6.088f)
                curveTo(10.4f, 6.088f, 10.4f, 6.088f, 10.4f, 6.088f)
                curveTo(10.4f, 6.088f, 10.4f, 6.088f, 10.08f, 5.551f)
                close()
                moveTo(10.705f, 5.58f)
                verticalLineTo(5.551f)
                horizontalLineTo(9.455f)
                verticalLineTo(5.58f)
                horizontalLineTo(10.705f)
                close()
                moveTo(9.778f, 6.128f)
                curveTo(9.849f, 6.167f, 9.978f, 6.235f, 10.125f, 6.295f)
                curveTo(10.252f, 6.347f, 10.472f, 6.427f, 10.7f, 6.427f)
                verticalLineTo(5.177f)
                curveTo(10.727f, 5.177f, 10.729f, 5.181f, 10.7f, 5.173f)
                curveTo(10.674f, 5.167f, 10.64f, 5.155f, 10.598f, 5.138f)
                curveTo(10.514f, 5.103f, 10.432f, 5.06f, 10.382f, 5.033f)
                lineTo(9.778f, 6.128f)
                close()
                moveTo(10.7f, 6.427f)
                curveTo(10.993f, 6.427f, 11.259f, 6.295f, 11.387f, 6.227f)
                curveTo(11.465f, 6.184f, 11.531f, 6.143f, 11.578f, 6.112f)
                curveTo(11.601f, 6.097f, 11.621f, 6.083f, 11.635f, 6.073f)
                curveTo(11.642f, 6.068f, 11.648f, 6.064f, 11.653f, 6.061f)
                curveTo(11.655f, 6.059f, 11.657f, 6.058f, 11.659f, 6.056f)
                curveTo(11.66f, 6.056f, 11.66f, 6.055f, 11.661f, 6.055f)
                curveTo(11.661f, 6.055f, 11.661f, 6.054f, 11.662f, 6.054f)
                curveTo(11.662f, 6.054f, 11.662f, 6.054f, 11.662f, 6.054f)
                curveTo(11.662f, 6.054f, 11.662f, 6.054f, 11.662f, 6.054f)
                curveTo(11.663f, 6.054f, 11.663f, 6.054f, 11.291f, 5.551f)
                curveTo(10.92f, 5.048f, 10.92f, 5.048f, 10.92f, 5.048f)
                curveTo(10.92f, 5.048f, 10.92f, 5.048f, 10.92f, 5.048f)
                curveTo(10.92f, 5.048f, 10.92f, 5.048f, 10.921f, 5.048f)
                curveTo(10.921f, 5.048f, 10.921f, 5.047f, 10.921f, 5.047f)
                curveTo(10.921f, 5.047f, 10.922f, 5.047f, 10.922f, 5.047f)
                curveTo(10.922f, 5.047f, 10.922f, 5.047f, 10.922f, 5.047f)
                curveTo(10.921f, 5.047f, 10.92f, 5.048f, 10.917f, 5.05f)
                curveTo(10.912f, 5.054f, 10.903f, 5.06f, 10.891f, 5.068f)
                curveTo(10.866f, 5.084f, 10.831f, 5.106f, 10.793f, 5.127f)
                curveTo(10.753f, 5.148f, 10.718f, 5.164f, 10.691f, 5.173f)
                curveTo(10.66f, 5.184f, 10.666f, 5.177f, 10.7f, 5.177f)
                verticalLineTo(6.427f)
                close()
                moveTo(10.781f, 5.912f)
                lineTo(11.351f, 6.716f)
                lineTo(12.371f, 5.994f)
                lineTo(11.801f, 5.19f)
                lineTo(10.781f, 5.912f)
                close()
                moveTo(11.861f, 6.355f)
                curveTo(11.297f, 6.086f, 11.297f, 6.086f, 11.297f, 6.086f)
                curveTo(11.297f, 6.087f, 11.296f, 6.087f, 11.296f, 6.087f)
                curveTo(11.296f, 6.087f, 11.296f, 6.088f, 11.296f, 6.088f)
                curveTo(11.295f, 6.089f, 11.295f, 6.089f, 11.295f, 6.09f)
                curveTo(11.294f, 6.092f, 11.293f, 6.093f, 11.292f, 6.095f)
                curveTo(11.291f, 6.099f, 11.288f, 6.104f, 11.286f, 6.109f)
                curveTo(11.281f, 6.121f, 11.275f, 6.135f, 11.268f, 6.152f)
                curveTo(11.253f, 6.187f, 11.235f, 6.234f, 11.215f, 6.292f)
                curveTo(11.175f, 6.408f, 11.127f, 6.57f, 11.091f, 6.767f)
                curveTo(11.019f, 7.162f, 10.99f, 7.712f, 11.172f, 8.32f)
                lineTo(12.37f, 7.963f)
                curveTo(12.258f, 7.589f, 12.274f, 7.246f, 12.321f, 6.992f)
                curveTo(12.344f, 6.866f, 12.373f, 6.766f, 12.396f, 6.7f)
                curveTo(12.407f, 6.668f, 12.417f, 6.644f, 12.422f, 6.631f)
                curveTo(12.425f, 6.625f, 12.427f, 6.621f, 12.427f, 6.619f)
                curveTo(12.427f, 6.619f, 12.427f, 6.619f, 12.427f, 6.62f)
                curveTo(12.427f, 6.62f, 12.427f, 6.621f, 12.426f, 6.621f)
                curveTo(12.426f, 6.622f, 12.426f, 6.622f, 12.426f, 6.623f)
                curveTo(12.425f, 6.623f, 12.425f, 6.623f, 12.425f, 6.623f)
                curveTo(12.425f, 6.624f, 12.425f, 6.624f, 12.425f, 6.624f)
                curveTo(12.425f, 6.624f, 12.425f, 6.624f, 11.861f, 6.355f)
                close()
                moveTo(11.172f, 8.32f)
                curveTo(11.295f, 8.734f, 11.246f, 8.954f, 11.181f, 9.057f)
                curveTo(11.127f, 9.142f, 10.959f, 9.306f, 10.41f, 9.342f)
                lineTo(10.49f, 10.589f)
                curveTo(11.246f, 10.54f, 11.885f, 10.284f, 12.238f, 9.724f)
                curveTo(12.581f, 9.181f, 12.54f, 8.532f, 12.37f, 7.963f)
                lineTo(11.172f, 8.32f)
                close()
                moveTo(10.45f, 9.965f)
                curveTo(10.333f, 9.351f, 10.333f, 9.351f, 10.333f, 9.351f)
                curveTo(10.333f, 9.351f, 10.333f, 9.351f, 10.333f, 9.351f)
                curveTo(10.333f, 9.351f, 10.333f, 9.352f, 10.333f, 9.352f)
                curveTo(10.333f, 9.352f, 10.332f, 9.352f, 10.332f, 9.352f)
                curveTo(10.332f, 9.352f, 10.331f, 9.352f, 10.33f, 9.352f)
                curveTo(10.329f, 9.352f, 10.328f, 9.352f, 10.326f, 9.353f)
                curveTo(10.323f, 9.353f, 10.318f, 9.354f, 10.313f, 9.355f)
                curveTo(10.303f, 9.358f, 10.288f, 9.361f, 10.271f, 9.364f)
                curveTo(10.238f, 9.372f, 10.191f, 9.383f, 10.139f, 9.398f)
                curveTo(10.06f, 9.42f, 9.876f, 9.474f, 9.725f, 9.578f)
                lineTo(10.436f, 10.606f)
                curveTo(10.406f, 10.627f, 10.392f, 10.63f, 10.412f, 10.622f)
                curveTo(10.427f, 10.616f, 10.449f, 10.609f, 10.476f, 10.601f)
                curveTo(10.502f, 10.594f, 10.527f, 10.588f, 10.545f, 10.584f)
                curveTo(10.554f, 10.582f, 10.56f, 10.581f, 10.564f, 10.58f)
                curveTo(10.566f, 10.58f, 10.568f, 10.579f, 10.568f, 10.579f)
                curveTo(10.568f, 10.579f, 10.568f, 10.579f, 10.568f, 10.579f)
                curveTo(10.568f, 10.579f, 10.568f, 10.579f, 10.568f, 10.579f)
                curveTo(10.567f, 10.579f, 10.567f, 10.579f, 10.567f, 10.579f)
                curveTo(10.567f, 10.579f, 10.567f, 10.579f, 10.567f, 10.579f)
                curveTo(10.567f, 10.579f, 10.567f, 10.579f, 10.567f, 10.579f)
                curveTo(10.567f, 10.579f, 10.567f, 10.579f, 10.45f, 9.965f)
                close()
                moveTo(10.705f, 10.164f)
                verticalLineTo(10.092f)
                horizontalLineTo(9.455f)
                verticalLineTo(10.164f)
                horizontalLineTo(10.705f)
                close()
                moveTo(9.617f, 10.559f)
                curveTo(9.573f, 10.517f, 9.455f, 10.382f, 9.455f, 10.164f)
                horizontalLineTo(10.705f)
                curveTo(10.705f, 9.91f, 10.568f, 9.742f, 10.492f, 9.667f)
                lineTo(9.617f, 10.559f)
                close()
                moveTo(9.617f, 9.667f)
                curveTo(9.54f, 9.742f, 9.403f, 9.91f, 9.403f, 10.164f)
                horizontalLineTo(10.653f)
                curveTo(10.653f, 10.382f, 10.536f, 10.517f, 10.492f, 10.559f)
                lineTo(9.617f, 9.667f)
                close()
                moveTo(10.653f, 10.164f)
                verticalLineTo(10.092f)
                horizontalLineTo(9.403f)
                verticalLineTo(10.164f)
                horizontalLineTo(10.653f)
                close()
                moveTo(9.658f, 9.965f)
                curveTo(9.542f, 10.579f, 9.542f, 10.579f, 9.542f, 10.579f)
                curveTo(9.542f, 10.579f, 9.542f, 10.579f, 9.542f, 10.579f)
                curveTo(9.541f, 10.579f, 9.541f, 10.579f, 9.541f, 10.579f)
                curveTo(9.541f, 10.579f, 9.541f, 10.579f, 9.541f, 10.579f)
                curveTo(9.541f, 10.579f, 9.541f, 10.579f, 9.54f, 10.579f)
                curveTo(9.54f, 10.579f, 9.54f, 10.579f, 9.54f, 10.579f)
                curveTo(9.541f, 10.579f, 9.542f, 10.58f, 9.544f, 10.58f)
                curveTo(9.548f, 10.581f, 9.555f, 10.582f, 9.564f, 10.584f)
                curveTo(9.582f, 10.588f, 9.607f, 10.594f, 9.633f, 10.601f)
                curveTo(9.66f, 10.609f, 9.682f, 10.616f, 9.697f, 10.622f)
                curveTo(9.717f, 10.63f, 9.703f, 10.627f, 9.673f, 10.606f)
                lineTo(10.384f, 9.578f)
                curveTo(10.233f, 9.474f, 10.048f, 9.42f, 9.97f, 9.398f)
                curveTo(9.917f, 9.383f, 9.871f, 9.372f, 9.837f, 9.364f)
                curveTo(9.82f, 9.361f, 9.806f, 9.358f, 9.795f, 9.355f)
                curveTo(9.79f, 9.354f, 9.786f, 9.353f, 9.782f, 9.353f)
                curveTo(9.781f, 9.352f, 9.779f, 9.352f, 9.778f, 9.352f)
                curveTo(9.777f, 9.352f, 9.777f, 9.352f, 9.776f, 9.352f)
                curveTo(9.776f, 9.352f, 9.776f, 9.352f, 9.776f, 9.352f)
                curveTo(9.776f, 9.352f, 9.776f, 9.351f, 9.775f, 9.351f)
                curveTo(9.775f, 9.351f, 9.775f, 9.351f, 9.775f, 9.351f)
                curveTo(9.775f, 9.351f, 9.775f, 9.351f, 9.658f, 9.965f)
                close()
                moveTo(7.739f, 7.963f)
                curveTo(7.569f, 8.532f, 7.527f, 9.181f, 7.87f, 9.724f)
                curveTo(8.224f, 10.284f, 8.862f, 10.54f, 9.618f, 10.589f)
                lineTo(9.699f, 9.342f)
                curveTo(9.149f, 9.306f, 8.981f, 9.142f, 8.927f, 9.057f)
                curveTo(8.862f, 8.954f, 8.813f, 8.734f, 8.937f, 8.32f)
                lineTo(7.739f, 7.963f)
                close()
                moveTo(8.248f, 6.355f)
                curveTo(7.684f, 6.624f, 7.683f, 6.624f, 7.683f, 6.624f)
                curveTo(7.683f, 6.624f, 7.683f, 6.624f, 7.683f, 6.623f)
                curveTo(7.683f, 6.623f, 7.683f, 6.623f, 7.683f, 6.623f)
                curveTo(7.683f, 6.622f, 7.682f, 6.622f, 7.682f, 6.621f)
                curveTo(7.682f, 6.621f, 7.682f, 6.62f, 7.681f, 6.62f)
                curveTo(7.681f, 6.619f, 7.681f, 6.619f, 7.681f, 6.619f)
                curveTo(7.682f, 6.621f, 7.684f, 6.625f, 7.686f, 6.631f)
                curveTo(7.692f, 6.644f, 7.701f, 6.668f, 7.712f, 6.7f)
                curveTo(7.735f, 6.766f, 7.765f, 6.866f, 7.788f, 6.992f)
                curveTo(7.834f, 7.246f, 7.851f, 7.589f, 7.739f, 7.963f)
                lineTo(8.937f, 8.32f)
                curveTo(9.118f, 7.712f, 9.09f, 7.162f, 9.018f, 6.767f)
                curveTo(8.981f, 6.57f, 8.934f, 6.408f, 8.894f, 6.292f)
                curveTo(8.874f, 6.234f, 8.855f, 6.187f, 8.841f, 6.152f)
                curveTo(8.834f, 6.135f, 8.827f, 6.121f, 8.823f, 6.109f)
                curveTo(8.82f, 6.104f, 8.818f, 6.099f, 8.816f, 6.095f)
                curveTo(8.815f, 6.093f, 8.814f, 6.092f, 8.814f, 6.09f)
                curveTo(8.813f, 6.089f, 8.813f, 6.089f, 8.813f, 6.088f)
                curveTo(8.812f, 6.088f, 8.812f, 6.087f, 8.812f, 6.087f)
                curveTo(8.812f, 6.087f, 8.812f, 6.087f, 8.812f, 6.086f)
                curveTo(8.812f, 6.086f, 8.812f, 6.086f, 8.248f, 6.355f)
                close()
                moveTo(8.307f, 5.19f)
                lineTo(7.738f, 5.994f)
                lineTo(8.758f, 6.716f)
                lineTo(9.327f, 5.912f)
                lineTo(8.307f, 5.19f)
                close()
                moveTo(9.408f, 5.177f)
                curveTo(9.442f, 5.177f, 9.448f, 5.184f, 9.417f, 5.173f)
                curveTo(9.39f, 5.164f, 9.355f, 5.148f, 9.316f, 5.127f)
                curveTo(9.277f, 5.106f, 9.243f, 5.084f, 9.218f, 5.068f)
                curveTo(9.206f, 5.06f, 9.197f, 5.054f, 9.191f, 5.05f)
                curveTo(9.189f, 5.048f, 9.187f, 5.047f, 9.187f, 5.047f)
                curveTo(9.186f, 5.047f, 9.186f, 5.047f, 9.187f, 5.047f)
                curveTo(9.187f, 5.047f, 9.187f, 5.047f, 9.187f, 5.047f)
                curveTo(9.188f, 5.047f, 9.188f, 5.048f, 9.188f, 5.048f)
                curveTo(9.188f, 5.048f, 9.188f, 5.048f, 9.188f, 5.048f)
                curveTo(9.188f, 5.048f, 9.188f, 5.048f, 9.188f, 5.048f)
                curveTo(9.188f, 5.048f, 9.189f, 5.048f, 8.817f, 5.551f)
                curveTo(8.446f, 6.054f, 8.446f, 6.054f, 8.446f, 6.054f)
                curveTo(8.446f, 6.054f, 8.446f, 6.054f, 8.446f, 6.054f)
                curveTo(8.446f, 6.054f, 8.447f, 6.054f, 8.447f, 6.054f)
                curveTo(8.447f, 6.054f, 8.447f, 6.055f, 8.448f, 6.055f)
                curveTo(8.448f, 6.055f, 8.449f, 6.056f, 8.45f, 6.056f)
                curveTo(8.451f, 6.058f, 8.453f, 6.059f, 8.456f, 6.061f)
                curveTo(8.46f, 6.064f, 8.466f, 6.068f, 8.473f, 6.073f)
                curveTo(8.488f, 6.083f, 8.507f, 6.097f, 8.531f, 6.112f)
                curveTo(8.578f, 6.143f, 8.644f, 6.184f, 8.722f, 6.227f)
                curveTo(8.849f, 6.295f, 9.116f, 6.427f, 9.408f, 6.427f)
                verticalLineTo(5.177f)
                close()
                moveTo(9.726f, 5.033f)
                curveTo(9.677f, 5.06f, 9.595f, 5.103f, 9.51f, 5.138f)
                curveTo(9.469f, 5.155f, 9.434f, 5.167f, 9.409f, 5.173f)
                curveTo(9.379f, 5.181f, 9.382f, 5.177f, 9.408f, 5.177f)
                verticalLineTo(6.427f)
                curveTo(9.636f, 6.427f, 9.857f, 6.347f, 9.983f, 6.295f)
                curveTo(10.13f, 6.235f, 10.259f, 6.167f, 10.33f, 6.128f)
                lineTo(9.726f, 5.033f)
                close()
                moveTo(10.653f, 5.58f)
                verticalLineTo(5.551f)
                horizontalLineTo(9.403f)
                verticalLineTo(5.58f)
                horizontalLineTo(10.653f)
                close()
                moveTo(10.028f, 5.551f)
                curveTo(9.708f, 6.088f, 9.708f, 6.088f, 9.708f, 6.088f)
                curveTo(9.708f, 6.088f, 9.708f, 6.088f, 9.708f, 6.088f)
                curveTo(9.708f, 6.088f, 9.708f, 6.088f, 9.708f, 6.088f)
                curveTo(9.708f, 6.088f, 9.708f, 6.088f, 9.708f, 6.088f)
                curveTo(9.708f, 6.088f, 9.709f, 6.088f, 9.709f, 6.088f)
                curveTo(9.709f, 6.088f, 9.709f, 6.088f, 9.709f, 6.088f)
                curveTo(9.709f, 6.088f, 9.71f, 6.089f, 9.71f, 6.089f)
                curveTo(9.711f, 6.089f, 9.712f, 6.09f, 9.713f, 6.09f)
                curveTo(9.715f, 6.092f, 9.717f, 6.093f, 9.721f, 6.095f)
                curveTo(9.727f, 6.099f, 9.735f, 6.104f, 9.746f, 6.11f)
                lineTo(10.362f, 5.022f)
                curveTo(10.356f, 5.019f, 10.352f, 5.016f, 10.349f, 5.015f)
                curveTo(10.348f, 5.014f, 10.348f, 5.014f, 10.347f, 5.014f)
                curveTo(10.347f, 5.013f, 10.347f, 5.013f, 10.347f, 5.014f)
                curveTo(10.347f, 5.014f, 10.348f, 5.014f, 10.348f, 5.014f)
                curveTo(10.348f, 5.014f, 10.348f, 5.014f, 10.348f, 5.014f)
                curveTo(10.348f, 5.014f, 10.348f, 5.014f, 10.348f, 5.014f)
                curveTo(10.348f, 5.014f, 10.348f, 5.014f, 10.348f, 5.014f)
                curveTo(10.348f, 5.014f, 10.348f, 5.014f, 10.348f, 5.014f)
                curveTo(10.348f, 5.014f, 10.348f, 5.014f, 10.348f, 5.014f)
                curveTo(10.348f, 5.014f, 10.348f, 5.014f, 10.028f, 5.551f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(7.236f, 3.551f)
                horizontalLineToRelative(6f)
                verticalLineToRelative(8f)
                horizontalLineToRelative(-6f)
                close()
                moveTo(10.054f, 5.566f)
                curveTo(10.071f, 5.556f, 10.08f, 5.551f, 10.08f, 5.551f)
                verticalLineTo(5.58f)
                curveTo(10.2f, 5.647f, 10.503f, 5.802f, 10.7f, 5.802f)
                curveTo(10.951f, 5.802f, 11.291f, 5.551f, 11.291f, 5.551f)
                lineTo(11.861f, 6.355f)
                curveTo(11.861f, 6.355f, 11.477f, 7.159f, 11.771f, 8.141f)
                curveTo(12.064f, 9.124f, 11.755f, 9.881f, 10.45f, 9.965f)
                curveTo(10.45f, 9.965f, 10.193f, 10.014f, 10.08f, 10.092f)
                verticalLineTo(10.164f)
                curveTo(10.08f, 10.146f, 10.071f, 10.129f, 10.054f, 10.113f)
                curveTo(10.038f, 10.129f, 10.028f, 10.146f, 10.028f, 10.164f)
                verticalLineTo(10.092f)
                curveTo(9.916f, 10.014f, 9.658f, 9.965f, 9.658f, 9.965f)
                curveTo(8.353f, 9.881f, 8.044f, 9.124f, 8.338f, 8.141f)
                curveTo(8.631f, 7.159f, 8.248f, 6.355f, 8.248f, 6.355f)
                lineTo(8.817f, 5.551f)
                curveTo(8.817f, 5.551f, 9.158f, 5.802f, 9.408f, 5.802f)
                curveTo(9.605f, 5.802f, 9.908f, 5.647f, 10.028f, 5.58f)
                verticalLineTo(5.551f)
                curveTo(10.028f, 5.551f, 10.038f, 5.556f, 10.054f, 5.566f)
                close()
                moveTo(10.054f, 5.566f)
                curveTo(10.071f, 5.556f, 10.08f, 5.551f, 10.08f, 5.551f)
                verticalLineTo(5.58f)
                curveTo(10.2f, 5.647f, 10.503f, 5.802f, 10.7f, 5.802f)
                curveTo(10.951f, 5.802f, 11.291f, 5.551f, 11.291f, 5.551f)
                lineTo(11.861f, 6.355f)
                curveTo(11.861f, 6.355f, 11.477f, 7.159f, 11.771f, 8.141f)
                curveTo(12.064f, 9.124f, 11.755f, 9.881f, 10.45f, 9.965f)
                curveTo(10.45f, 9.965f, 10.193f, 10.014f, 10.08f, 10.092f)
                verticalLineTo(10.164f)
                curveTo(10.08f, 10.146f, 10.071f, 10.129f, 10.054f, 10.113f)
                curveTo(10.038f, 10.129f, 10.028f, 10.146f, 10.028f, 10.164f)
                verticalLineTo(10.092f)
                curveTo(9.916f, 10.014f, 9.658f, 9.965f, 9.658f, 9.965f)
                curveTo(8.353f, 9.881f, 8.044f, 9.124f, 8.338f, 8.141f)
                curveTo(8.631f, 7.159f, 8.248f, 6.355f, 8.248f, 6.355f)
                lineTo(8.817f, 5.551f)
                curveTo(8.817f, 5.551f, 9.158f, 5.802f, 9.408f, 5.802f)
                curveTo(9.605f, 5.802f, 9.908f, 5.647f, 10.028f, 5.58f)
                verticalLineTo(5.551f)
                curveTo(10.028f, 5.551f, 10.038f, 5.556f, 10.054f, 5.566f)
                close()
            }
        ) {
            path(fill = SolidColor(Color(0xFF67BAFF))) {
                moveTo(8.315f, 5.455f)
                horizontalLineToRelative(1.739f)
                verticalLineToRelative(2.386f)
                horizontalLineToRelative(-1.739f)
                close()
            }
            path(fill = SolidColor(Color.White)) {
                moveTo(10.054f, 5.455f)
                horizontalLineToRelative(1.739f)
                verticalLineToRelative(2.386f)
                horizontalLineToRelative(-1.739f)
                close()
            }
            path(fill = SolidColor(Color(0xFFC51918))) {
                moveTo(8.098f, 8.068f)
                horizontalLineToRelative(4.348f)
                verticalLineToRelative(2.727f)
                horizontalLineToRelative(-4.348f)
                close()
            }
            path(fill = SolidColor(Color(0xFFC9A951))) {
                moveTo(10.897f, 7.672f)
                horizontalLineTo(10.679f)
                verticalLineTo(6.038f)
                horizontalLineTo(10.897f)
                verticalLineTo(7.672f)
                close()
            }
            path(fill = SolidColor(Color(0xFFC9A951))) {
                moveTo(10.809f, 6.928f)
                lineTo(10.703f, 7.118f)
                lineTo(10.327f, 6.909f)
                lineTo(10.433f, 6.719f)
                lineTo(10.809f, 6.928f)
                close()
            }
            path(fill = SolidColor(Color(0xFFC9A951))) {
                moveTo(10.809f, 6.474f)
                lineTo(10.703f, 6.664f)
                lineTo(10.327f, 6.454f)
                lineTo(10.433f, 6.264f)
                lineTo(10.809f, 6.474f)
                close()
            }
            path(fill = SolidColor(Color(0xFFC9A951))) {
                moveTo(10.762f, 6.928f)
                lineTo(10.868f, 7.118f)
                lineTo(11.243f, 6.909f)
                lineTo(11.137f, 6.719f)
                lineTo(10.762f, 6.928f)
                close()
            }
            path(fill = SolidColor(Color(0xFFC9A951))) {
                moveTo(10.762f, 6.474f)
                lineTo(10.868f, 6.664f)
                lineTo(11.243f, 6.454f)
                lineTo(11.137f, 6.264f)
                lineTo(10.762f, 6.474f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFBCD17)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(11.081f, 8.566f)
                curveTo(11.081f, 8.566f, 11.232f, 8.393f, 11.232f, 8.479f)
                curveTo(11.232f, 8.566f, 11.232f, 8.711f, 11.156f, 8.711f)
                curveTo(11.081f, 8.711f, 10.729f, 8.642f, 10.594f, 8.479f)
                curveTo(10.46f, 8.316f, 10.176f, 8.033f, 9.811f, 8.1f)
                curveTo(9.445f, 8.167f, 9.012f, 8.64f, 8.905f, 8.64f)
                curveTo(8.798f, 8.64f, 8.564f, 9.006f, 8.735f, 9.291f)
                curveTo(8.905f, 9.576f, 9.195f, 9.487f, 9.195f, 9.57f)
                curveTo(9.195f, 9.653f, 9.268f, 9.662f, 9.539f, 9.662f)
                curveTo(9.811f, 9.662f, 9.91f, 9.758f, 10.145f, 9.758f)
                curveTo(10.38f, 9.758f, 10.068f, 9.755f, 10.446f, 9.662f)
                curveTo(10.825f, 9.57f, 11.112f, 9.291f, 10.891f, 9.291f)
                curveTo(10.67f, 9.291f, 10.599f, 9.291f, 10.446f, 9.291f)
                curveTo(10.293f, 9.291f, 9.953f, 9.401f, 9.953f, 9.291f)
                curveTo(9.953f, 9.181f, 10.029f, 8.945f, 10.238f, 9.063f)
                curveTo(10.446f, 9.181f, 11.026f, 9.27f, 11.232f, 9.063f)
                curveTo(11.438f, 8.855f, 11.509f, 8.729f, 11.474f, 8.479f)
                curveTo(11.438f, 8.229f, 11.156f, 8.301f, 11.156f, 8.301f)
                lineTo(11.081f, 8.566f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFD18219)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(9.61f, 5.981f)
                curveTo(9.479f, 6.096f, 9.564f, 6.515f, 9.349f, 6.515f)
                curveTo(9.134f, 6.515f, 8.832f, 6.201f, 8.756f, 6.408f)
                curveTo(8.68f, 6.615f, 8.756f, 6.545f, 8.756f, 6.722f)
                curveTo(8.756f, 6.898f, 8.574f, 7.388f, 8.665f, 7.471f)
                curveTo(8.756f, 7.553f, 8.849f, 7.772f, 8.833f, 7.669f)
                curveTo(8.817f, 7.567f, 8.748f, 7.417f, 8.777f, 7.254f)
                curveTo(8.749f, 7.086f, 8.93f, 6.924f, 8.93f, 6.924f)
                curveTo(8.93f, 6.924f, 8.911f, 7.099f, 8.896f, 7.164f)
                curveTo(8.896f, 7.164f, 8.837f, 7.296f, 8.861f, 7.383f)
                curveTo(8.861f, 7.383f, 8.922f, 7.629f, 8.948f, 7.646f)
                curveTo(8.948f, 7.646f, 8.964f, 7.063f, 8.983f, 6.967f)
                curveTo(9.001f, 6.871f, 9.135f, 7.075f, 9.179f, 7.052f)
                curveTo(9.179f, 7.052f, 9.194f, 7.451f, 9.171f, 7.498f)
                curveTo(9.171f, 7.498f, 9.124f, 7.593f, 9.142f, 7.623f)
                curveTo(9.142f, 7.623f, 9.185f, 7.732f, 9.222f, 7.7f)
                curveTo(9.222f, 7.7f, 9.223f, 7.698f, 9.242f, 7.592f)
                curveTo(9.242f, 7.592f, 9.22f, 7.528f, 9.254f, 7.381f)
                curveTo(9.254f, 7.381f, 9.29f, 7.06f, 9.305f, 7.13f)
                curveTo(9.305f, 7.13f, 9.299f, 7.282f, 9.316f, 7.36f)
                curveTo(9.316f, 7.36f, 9.343f, 7.554f, 9.349f, 7.575f)
                curveTo(9.349f, 7.575f, 9.48f, 7.762f, 9.483f, 7.683f)
                curveTo(9.483f, 7.683f, 9.357f, 7.533f, 9.384f, 7.419f)
                curveTo(9.384f, 7.419f, 9.312f, 7.096f, 9.413f, 7.024f)
                curveTo(9.413f, 7.024f, 9.68f, 6.901f, 9.696f, 6.689f)
                curveTo(9.696f, 6.689f, 9.734f, 6.449f, 9.741f, 6.339f)
                curveTo(9.741f, 6.339f, 9.683f, 6.306f, 9.804f, 6.249f)
                curveTo(9.804f, 6.249f, 9.998f, 6.175f, 9.877f, 6.071f)
            }
        }
    }.build()
}

@Preview
@Composable
private fun PeruPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Medium.Peru,
            contentDescription = "Peru Flag"
        )
    }
}
